export default "__VITE_ASSET__DTxgrp0G__"